import { Box } from '@chakra-ui/react';
import styles from "../Common/Style/Style.module.css"
import { CorporateLandingComponent } from './Component/Landing.component';
import { useParams } from 'react-router-dom';
import { Navbar } from '../Common/Component/Navbar.component';
import { Login } from '../Common/Component/Login.component';
import { Footer } from '../Common/Component/Footer.component';

const Corporate = () => {
    const { company } = useParams<{ company ?: string }>();

    const isLogin = !!company; 

    return (
        <Box className={styles.wrapper}>
            <Box className={styles.container}>
                <Navbar />
                {!isLogin ? (
                    <CorporateLandingComponent/>
                ) : (
                    <Login/>
                )}
                <Footer/>
            </Box>
        </Box>
    );
};

export default Corporate;
